var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lottery-record-pane" }, [
    _c(
      "div",
      { staticClass: "search-area" },
      [
        _c(
          "el-form",
          {
            staticClass: "search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("phone-user-select", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "请输入手机号" },
                  on: { select: _vm.handlePhoneUserSelect },
                  model: {
                    value: _vm.searchForm.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "userId", $$v)
                    },
                    expression: "searchForm.userId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "请选择奖品", clearable: "" },
                    model: {
                      value: _vm.searchForm.prizeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "prizeName", $$v)
                      },
                      expression: "searchForm.prizeName",
                    },
                  },
                  _vm._l(_vm.prizeNameList, function (prize) {
                    return _c("el-option", {
                      key: prize.name,
                      attrs: { label: prize.name, value: prize.name },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "请选择发放状态", clearable: "" },
                    model: {
                      value: _vm.searchForm.isSend,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "isSend", $$v)
                      },
                      expression: "searchForm.isSend",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "已发放", value: 1 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "待发放", value: 0 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "发放失败", value: 2 } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "400px" },
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    format: "yyyy-MM-dd HH:mm:ss",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                    "default-time": ["00:00:00", "23:59:59"],
                  },
                  model: {
                    value: _vm.searchForm.dateRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "dateRange", $$v)
                    },
                    expression: "searchForm.dateRange",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("\n            查询\n          ")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("\n            重置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", loading: _vm.exportLoading },
                    on: { click: _vm.handleExport },
                  },
                  [_vm._v("\n            导出\n          ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-area" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "id",
                label: "ID",
                align: "center",
                "min-width": "80",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "用户",
                align: "left",
                "min-width": "160",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "user-info-wrapper" },
                        [
                          _c("el-avatar", {
                            staticClass: "user-avatar",
                            attrs: {
                              src: _vm.getAvatarUrl(scope.row.userpic),
                              size: 40,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-detail" }, [
                            _c("div", { staticClass: "user-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row.alias || "-") +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-mobile" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row.mobilePhone || "-") +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "user-rank" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getUserRankTagType(
                                        scope.row.userRank
                                      ),
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getUserRankName(
                                            scope.row.userRank
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "奖品",
                align: "center",
                "min-width": "200",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "prize-info" },
                        [
                          _vm.getPrizeImageUrl(scope.row.award)
                            ? _c(
                                "el-image",
                                {
                                  staticClass: "prize-image",
                                  attrs: {
                                    src: _vm.getPrizeImageUrl(scope.row.award),
                                    fit: "cover",
                                    "preview-src-list": _vm.getPrizeImageUrl(
                                      scope.row.award
                                    )
                                      ? [_vm.getPrizeImageUrl(scope.row.award)]
                                      : [],
                                    "preview-teleported": "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "prize-name" }, [
                            _vm._v(_vm._s(_vm.getPrizeName(scope.row.award))),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "奖品类型", align: "center", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getPrizeTypeTag(scope.row.award),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getPrizeTypeName(scope.row.award)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "机会来源", align: "center", "min-width": "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getSourceTypeTag(scope.row.stype),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getSourceTypeName(scope.row.stype)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "是否加入企微", align: "center", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.isQwe === 1
                        ? _c(
                            "el-tag",
                            { attrs: { type: "warning", size: "small" } },
                            [_vm._v("\n              是\n            ")]
                          )
                        : scope.row.isQwe === 0
                        ? _c(
                            "el-tag",
                            { attrs: { type: "info", size: "small" } },
                            [_vm._v("\n              否\n            ")]
                          )
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "是否是新用户", align: "center", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.isNewReg === 1
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "small" } },
                            [_vm._v("\n              是\n            ")]
                          )
                        : scope.row.isNewReg === 0
                        ? _c(
                            "el-tag",
                            { attrs: { type: "info", size: "small" } },
                            [_vm._v("\n              否\n            ")]
                          )
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "抽奖时间", align: "center", "min-width": "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatTime(scope.row.addTime)) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "发放状态", align: "center", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getSendStatusTagType(
                              scope.row.sendStatus
                            ),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.getSendStatusText(scope.row.sendStatus)
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                "min-width": "120",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      (scope.row.sendStatus === 0 ||
                        scope.row.sendStatus === 2) &&
                      _vm.getIsWin(scope.row.award)
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                loading: _vm.sendLoadingMap[scope.row.id],
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSendPrize(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              发放\n            ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-area" },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }